import { useLayoutEffect, useState } from 'react'
import { Size } from 'types/size'

export const useWindowSize = () => {
  const [size, setSize] = useState<Size>({
    width: 0,
    height: 0
  })

  useLayoutEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight
      })
    }

    const debounceSetResize = debounce(handleResize, 300)

    handleResize()
    window.addEventListener('resize', debounceSetResize)

    return () => {
      window.removeEventListener('resize', debounceSetResize)
    }
  }, [])

  return size
}

const debounce = <T extends Function>(func: T, delay: number) => {
  let timer: NodeJS.Timeout

  return function (...args: any[]) {
    clearTimeout(timer)

    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}
